// src/ramda-adjunct/isNotNil.ts
import isNil from "ramda/src/isNil";
function isNotNil(val) {
  return !isNil(val);
}
var isNotNil_default = isNotNil;

export {
  isNotNil_default
};
//# sourceMappingURL=chunk-QP3PPONL.mjs.map